<template>
  <div class="edit-retailer">
    <mdb-card>
      <mdb-card-header class="pt-4 indigo">
        <mdb-card-title class="text-white"><strong>{{ $t("unionmember") }}</strong></mdb-card-title>
      </mdb-card-header>
      <mdb-card-body>
        <mdb-row class="mt-5">
          <mdb-col md="6">
            <mdb-input :label="$t('unionmember_id')" type="text" v-model="id" :disabled="this.$route.params.id" />
          </mdb-col>
          <mdb-col md="6">
            <mdb-input :label="$t('unionmember_name')" type="text" v-model="name" />
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-5">
          <mdb-col md="3">
            <mdb-btn @click="saveUnionmember" color="indigo" class="white-text" icon="paper-plane">{{ $t("save") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
  mdbInput,
} from "mdbvue";

export default {
  name: "EditUnionmember",
  components: {
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    mdbInput,
  },
  props: {
    notificationType: String,
    defaultMarker: Object,
  },
  methods: {
    loadUnionmember() {
      if (this.$route.params.id) {
        this.getUnionmember(this.$route.params.id);
      } else {
        this.loadReady = true;
      }
    },
    fillLocalUnionmember(unionmember) {
      this.id = unionmember.id;
      this.name = unionmember.name;
    },
    getUnionmember(id) {
      this.$notify.info({
        message: this.$t("loading_unionmember"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.$http
        .get(this.getunionmemberpath + id)
        .then((response) => {
          if (response.status == 200) {
            this.fillLocalUnionmember(response.data.unionmembers[0]);
            this.loadReady = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    saveUnionmember() {
      try {
        this.postData = {
          id: this.id,
          name: this.name,
        };
        console.log(this.postData);
        this.$http
          .post(this.editunionmemberpath, JSON.stringify(this.postData))
          .then((response) => {
            if (response.status == 200) {
              this.$notify.success({
                message: this.$t("adding_unionmember_success"),
                position: "top right",
                timeOut: this.$store.state.notifytimeoutshort,
              });
              this.$router.push("/unionmembers");
            }
          })
          .catch((error) => {
            this.$notify.error({
              message: this.$t("adding_unionmember_not_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.loadUnionmember();
  },
  data() {
    return {
      editunionmemberpath: "/1.0/front/unionmember",
      getunionmemberpath: "/1.0/front/unionmember/",
      id: "",
      name: "",
      loadReady: false,
    };
  },
};
</script>

<style></style>
